import { stateToDiscountOrder } from 'lib/promo/promoMappers'
import { hasValidExperienceUpsellMetadata } from 'checkout/selectors/view/experienceUpsellPricing'

export default function buildExperienceUpsellDiscountOrder(state: App.State) {
  // Price the unmodified tickets even while the previous promotion is being revalidated.
  const order = stateToDiscountOrder({
    ...state,
    checkout: {
      ...state.checkout,
      promo: undefined,
      isFetchingPromo: false,
      cart: { ...state.checkout.cart, experienceUpsellBenefit: undefined },
    },
  })
  return hasValidExperienceUpsellMetadata(state) ? order : { ...order, items: [] }
}
